module.exports = __webpack_public_path__ + "static/media/resetPasswordImg.5cbe1ff9.svg";